import React from "react";
import {
  TriggerScreenshotIcon,
  TriggerShakeIcon,
  TriggerWarningIcon,
  TriggerCustomIcon,
  TriggerFloatingButtonIcon,
} from "../icons"; // Adjust path as needed
import {
  PulseButton,
  PulseButtonSizes,
  PulseButtonTheme,
} from "@pulselabs-ai/shared-fe-ui"; // Adjust path as needed

interface TriggerButtonProps {
  triggerType: string;
  status?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onSetupClick?: () => void; // For custom draft state
  disabled?: boolean;
  theme?: PulseButtonTheme;
  size?: PulseButtonSizes;
}

const TriggerButton: React.FC<TriggerButtonProps> = ({
  triggerType,
  status = "ACTIVE",
  onClick,
  onSetupClick,
  disabled = false,
  theme = PulseButtonTheme.LINK,
  size = PulseButtonSizes.EXTRA_SMALL,
}) => {
  let IconComponent: React.FC<React.SVGProps<SVGSVGElement>> | null = null;
  let label: string = "";

  switch (triggerType) {
    case "Shake":
      IconComponent = TriggerShakeIcon;
      label = "SHAKE DEVICE";
      break;
    case "Screenshot":
      IconComponent = TriggerScreenshotIcon;
      label = "SCREEN GRAB";
      break;
    case "FloatingButton":
      IconComponent = TriggerFloatingButtonIcon;
      label = "FLOATING BUTTON"; // FLOATING BUTTON, need to resize to fit
      break;
    case "Custom":
      if (status === "DRAFT") {
        IconComponent = TriggerWarningIcon;
        label = "REQUIRES SETUP";
        // Render span for draft custom trigger
        return (
          <span onClick={onSetupClick} style={{ cursor: "pointer" }}>
            {/* Optionally include the warning icon here too */}
            {label}
          </span>
        );
      } else {
        IconComponent = TriggerCustomIcon;
        label = "CUSTOM";
      }
      break;
    default:
      // Optional: Handle unknown trigger types
      return null;
  }

  // Render PulseButton for all other cases
  return (
    <PulseButton
      startIcon={IconComponent ? <IconComponent /> : undefined}
      theme={theme}
      size={size}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </PulseButton>
  );
};

export default TriggerButton;
